module.exports = __webpack_public_path__ + "img/redeem_form1_en.bfe7fd2c.jpg";